import api from './api'

export const getBrandList = async () => await api.get('/bank/')  

export const setBankAccount = (user_id, bank_account  ) =>
  new Promise((resolve, reject) => {
    api
      .post(`/professional/${user_id}/set_bank_account_v2/`, bank_account)  
      .then(res => resolve(res.data))
      .catch(error => reject(error))
  })

export const getBankAccounts = (user_id, page  ) =>
  new Promise((resolve, reject) => {
    api
      .get(`/professional/${user_id}/get_bank_accounts/?page=${page || 1}`)  
      .then(res => {
        let response = {}
        response.page = res.data.page
        response.total = Math.ceil(res.data.count / 10)
        response.userAccounts = res.data.content
        resolve(response)
      })
      .catch(error => reject(error))
  })
